import { api } from "./base";

export const getPages = async ({ locale }) => {
  api.defaults.headers = { locale };
  const res = await api.get("/pages");
  return res.data;
};
